import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { GetDetailedRecentsRequest } from '~src/recents/requests/GetDetailedRecentsRequest';
import { ExplorableItemType, ExplorableItemTypeValue } from '~src/spacesPlatform/models/ContentType';
import { ViewStatFields } from '~src/spacesPlatform/models/ContentTypes';
import { IListFetcher } from '~src/ts/fetchers/IListFetcher';
import { ServerApiMapper} from '~src/ts/helpers/ServerModelHelper';
import { IRecentContentInfo } from '~src/ts/models/IRecentContentInfo';
import { IUserInfo } from '~src/ts/models/IUserInfo';
import { OrderKeys } from '~src/ts/models/OrderKeys';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';
import { ILeafFilterClause } from '~src/ts/ServerApi/types/IFilterClause';
import { IOrderClause } from '~src/ts/ServerApi/types/IOrderClause';

class RecentsResource {

  private getRecentViews: IListFetcher<IRecentContentInfo> = new WebClientListResourceFetcher(
    GetDetailedRecentsRequest, ServerApiMapper.recentItems);

  private getRecentUsersFetcher: IListFetcher<IUserInfo> = new WebClientListResourceFetcher(
    GetDetailedRecentsRequest, ServerApiMapper.recentUniqueUsers);

  public all(contentTypes: ReadonlyArray<ExplorableItemType>, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IRecentContentInfo> {
    const objectTypes: string[] = this.getObjectTypes(contentTypes);

    return new ResourceQuery(this.getRecentViews)
      .withExtraParams({viewStatFields: ViewStatFields, objectTypes: objectTypes})
      .withFilters(additionalFilterClauses);
  }

  public users(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IUserInfo> {
    const contentTypes = [ExplorableItemTypeValue.view, ExplorableItemTypeValue.metric, ExplorableItemTypeValue.flow];
    const objectTypes = this.getObjectTypes(contentTypes);
    const order: IOrderClause[] = [{ field: OrderKeys.lastAccessedAt, ascending: false}];
    return new ResourceQuery(this.getRecentUsersFetcher)
              .withExtraParams({viewStatFields: ViewStatFields, objectTypes: objectTypes})
              .withOrder(order)
              .withFilters(additionalFilterClauses);
  }

  private getObjectTypes(contentTypes: ReadonlyArray<ExplorableItemType>): string[] {
    const objectTypes = contentTypes.map((contentType) => {
      switch(contentType){
        case 'view':
          return 'VIEW';
        case 'metric':
          return 'METRIC';
        case 'flow':
          return 'FLOW';
        default:
          return '';
      }
    }).filter((value => value.length > 0));

    if (objectTypes.length === 0) {
      return ['VIEW'];
    }

    return objectTypes;
  }
}

export const Recents = new RecentsResource();
